import * as React from "react";
import { Routes, Route, useNavigate, useLocation, Link, useMatch } from "react-router-dom";
import { Anchor, Box, Button, Grommet, Image, ResponsiveContext, Page, Text, Stack } from "grommet";
import { Account, GetCurrentLogin, usePermission, useUser } from "./account/AccountStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StyledModal from "./components/StyledModel";
import { AppBarItem, NavigationButton } from "./components/NavigationButton";

export const Nav = (user, onClick) => {
    return [
        <AppBarItem key={"profile"}>
            <Anchor href={"/"}>
                <Box className="app-bar-text" align="end" justify="end" hoverIndicator="background-front" pad={{ horizontal: "small", vertical: "xsmall" }} round="5px" onClick={() => {}}>
                    <Text>{"My Profile"}</Text>
                </Box>
            </Anchor>
        </AppBarItem>,
        <NavigationButton onClick={onClick} key={"home"} href={"/"} text="Home"></NavigationButton>,
        <NavigationButton onClick={onClick} key={"games"} href={"/games"} text="Games"></NavigationButton>,
        <NavigationButton onClick={onClick} key={"maps"} href={"/maps"} text="Maps"></NavigationButton>,
        user.hasPermission("sport:teams.read") && <NavigationButton onClick={onClick} key={"teams"} href={"/teams"} text="Teams"></NavigationButton>,
        user.hasPermission("sport:aliases.read") && <NavigationButton onClick={onClick} key={"aliases"} href={"/aliases"} text="Players"></NavigationButton>,
        user.hasPermission("sport:coaches.read") && <NavigationButton onClick={onClick} key={"coaches"} href={"/coaches"} text="Coaches"></NavigationButton>,
        user.hasPermission("sport:matches.read") && <NavigationButton onClick={onClick} key={"matches"} href={"/matches"} text="Matches"></NavigationButton>,
        user.hasPermission("sport:tournaments.read") && <NavigationButton onClick={onClick} key={"tournaments"} href={"/tournaments"} text="Tournaments"></NavigationButton>,
        user.hasPermission("sport:leagues.read") && <NavigationButton onClick={onClick} key={"leagues"} href={"/leagues"} text="Leagues"></NavigationButton>,
        user.hasPermission("sport:seedMatches.read") && <NavigationButton onClick={onClick} key={"seedMatches"} href={"/seedMatches"} text="Seeding"></NavigationButton>,
        user.hasPermission("admin") && <NavigationButton onClick={onClick} key={"admin"} href={"/admin"} text="Admin"></NavigationButton>,
    ].filter((x) => x);
};

const AppBar = () => {
    let user = useUser();

    const size = React.useContext(ResponsiveContext);

    const [showNav, setShowNav] = React.useState(false);

    return (
        <>
            {size !== "small" && (
                <Box fill="horizontal">
                    <Box background="" border={{ color: "brand", side: "bottom", size: "small" }} responsive direction="row" wrap gap="medium" pad="small" margin={{ bottom: "small" }} align="center" justify="center">
                        <Box width={"200px"}>
                            <Image src={window.identityServer + "static/branding/images/logo"} style={{ maxHeight: "50px", maxWidth: "200px", objectFit: "contain" }}></Image>
                        </Box>
                        {...Nav(user, () => setShowNav(false))}
                        <Box width={"200px"}></Box>
                    </Box>
                </Box>
            )}
            {size === "small" && (
                <Stack fill="horizontal" anchor="left" margin={{ top: "45px" }}>
                    <Box align="center" fill="horizontal">
                        <Image src={window.identityServer + "static/branding/images/logo"} style={{ maxHeight: "50px", maxWidth: "200px", objectFit: "contain" }}></Image>
                    </Box>
                    <Button size="large" icon={<FontAwesomeIcon icon={["fad", "bars"]} />} onClick={() => setShowNav(true)}></Button>
                </Stack>
            )}

            <StyledModal isOpen={showNav} setIsOpen={setShowNav}>
                {...Nav(user, () => setShowNav(false))}
            </StyledModal>

            {user.hasRole("Admin") && (
                <Box style={{ position: "absolute", right: "80px", top: "15px", zIndex: 10 }} align="end">
                    <Anchor
                        href={`/account/signin`}
                        onClick={(e) => {
                            e.preventDefault();
                            window.location = `/account/signin?select=true&redirectUrl=${encodeURIComponent(window.location.pathname)}` as any;
                        }}
                        label={
                            <Box direction="row" gap="small">
                                <Text>{user.organization.name}</Text>
                                <FontAwesomeIcon size="xl" icon={["fad", "arrows-left-right"]}></FontAwesomeIcon>
                            </Box>
                        }
                        title="Switch Organization"
                    ></Anchor>
                </Box>
            )}
            {!user.hasRole("Admin") && (
                <Box style={{ position: "absolute", right: "80px", top: "15px", zIndex: 10 }} align="end">
                    <Anchor
                        href={`/account/signin`}
                        onClick={(e) => {
                            e.preventDefault();
                            window.location = `/account/signin?select=true&redirectUrl=${encodeURIComponent(window.location.pathname)}` as any;
                        }}
                        label={user.organization.name}
                    ></Anchor>
                </Box>
            )}
        </>
    );
};

export default AppBar;
